import { QueryClient } from '@tanstack/react-query'

import { isApiError } from '@/lib/api'
import { getSessionLifecycle } from '@/lib/session-cache'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
      // Never hammer a host that answered deliberately (4xx/5xx); retry only network blips.
      retry: (failureCount, error) => (isApiError(error) && error.status !== 0 ? false : failureCount < 1),
    },
    mutations: { retry: false },
  },
})

getSessionLifecycle(queryClient)
